export const apiUrl = "https://api.tvmaze.com/search/shows?q=girls";
